<div class="logo logo__text">
  <div class="logo__text--icon" (click)="navigateToLoginLanding()">
    <img *ngIf="hasLogo else defaultLogo" class="custom-logo" [attr.src]="logo"/>
    <ng-template #defaultLogo>
    <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-text--red"></app-icon>
    </ng-template>
  </div>
</div>